import { HTMLAttributes } from "react";
import { cn } from "@/utils/cn";
import Image from "@/components/common/Image";

interface BentoItem {
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
}

interface Bento3Props extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  items: BentoItem[];
}

export const Bento3 = ({
  title = "We disrupted the sub-optimal integration experience and made it flexible, real-time & embeddable",
  description = "Say goodbye to authentication hassles, data mapping puzzles and infrastructure maintenance nightmares",
  items,
  className,
  ...props
}: Bento3Props) => {
  return (
    <section className={cn("py-24", className)} {...props}>
      <div className="container mx-auto px-4 max-w-7xl">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">{title}</h2>
          <p className="text-lg text-gray-600">{description}</p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((item, index) => (
            <div key={index} className="flex flex-col">
              <div className="relative mb-2 bg-gray-50 rounded-xl p-4">
                <Image
                  src={item.imageSrc}
                  alt={item.imageAlt}
                  width={400}
                  height={300}
                  className="w-full rounded-md h-auto object-contain"
                />
              </div>
              <div className="px-4">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
